import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _get from "@babel/runtime/helpers/get";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { DragTargetHandler } from "./base/DragTargetHandler";
import { extractCursorPoint, getActionEdge } from "../helpers";
export var NodeDragTargetHandler = /*#__PURE__*/function (_DragTargetHandler) {
  _inherits(NodeDragTargetHandler, _DragTargetHandler);
  var _super = _createSuper(NodeDragTargetHandler);
  function NodeDragTargetHandler(dragStatus, nodeRegistry) {
    var _thisSuper, _this;
    _classCallCheck(this, NodeDragTargetHandler);
    _this = _super.call(this);
    _this.dragStatus = dragStatus;
    _this.nodeRegistry = nodeRegistry;
    _defineProperty(_assertThisInitialized(_this), "handleDrop", function (event, _ref) {
      var nodeId = _ref.nodeId,
        uniqueId = _ref.uniqueId;
      if (!_this.dragStatus.getIsDragging()) return;
      // FIXME: DRY & responsibility
      var nodeElement = _this.nodeRegistry.findClosestDOMParent(event.target);
      if (!nodeElement) return;

      // NOTE: Функционал DND в контенте страницы отключен, т.к. вызывает больше проблем со случайными кликами,
      //   чем реальной пользы
      if (_this.dragStatus.isPlatformGui()) {
        _this.dragStatus.handleEntityDrop({
          nodeId: nodeId,
          uniqueId: uniqueId,
          side: getActionEdge(nodeElement, extractCursorPoint(event))
        });
      } else {
        _this.dragStatus.handleNodeDragEnd();
      }
      _get((_thisSuper = _assertThisInitialized(_this), _getPrototypeOf(NodeDragTargetHandler.prototype)), "handleDrop", _thisSuper).call(_thisSuper, event);
    });
    return _this;
  }
  _createClass(NodeDragTargetHandler, [{
    key: "handleDragOverEnter",
    value: function handleDragOverEnter(event, _ref2) {
      var nodeId = _ref2.nodeId,
        uniqueId = _ref2.uniqueId;
      // FIXME: DRY & responsibility
      if (!this.dragStatus.getIsDragging() || !this.dragStatus.isPlatformGui()) return;
      var nodeElement = this.nodeRegistry.findClosestDOMParent(event.target);
      if (!nodeElement) return;
      this.dragStatus.handleNodeDrag({
        nodeId: nodeId,
        uniqueId: uniqueId,
        side: getActionEdge(nodeElement, extractCursorPoint(event))
      });
      _get(_getPrototypeOf(NodeDragTargetHandler.prototype), "handleDragOverEnter", this).call(this, event);
    }
  }, {
    key: "handleDragLeave",
    value: function handleDragLeave(event) {
      this.dragStatus.handleNodeDragLeave();
      _get(_getPrototypeOf(NodeDragTargetHandler.prototype), "handleDragLeave", this).call(this, event);
    }
  }]);
  return NodeDragTargetHandler;
}(DragTargetHandler);